module.exports = __webpack_public_path__ + "img/streamline-icon-trolley-baggage@450x450.e05367eb.svg";